<pf-auth-layout *ngIf="!isLoading">
  <ng-container class="auth-content">
  </ng-container>
</pf-auth-layout>

<pf-loading-overlay></pf-loading-overlay>
